export default "__VITE_ASSET__BtB3YkC___"